import './modalContent.css'

export default function TimsPlanetSign() {
  return (
    <div className='modal-content'>
      <h1 className='modal-header'>Welcome to Tim's Planet!</h1>
      <h2 className='modal-subheader'>A Journey Through Creativity and Experience</h2>
      <div className='modal-body'>
        <h3>Embark on an Extraordinary Exploration</h3>
        <p>
          Welcome, traveler, to the enchanting world of Planet Tim – a unique and immersive 3D environment crafted to
          take you on a journey through my professional accomplishments, educational background, personal story, and
          interests. As you navigate this vibrant and interactive world, you'll discover the landmarks that define my
          life and career.
        </p>
        <h2>Discover the Landmarks of My Life</h2>
        <ul>
          <li>
            <p>
              <strong>The Well of Knowledge: </strong>
              Delve deep into the waters of my educational background. Here, each ripple tells a story of learning and
              growth, revealing the academic pursuits and skills that have shaped my professional journey.
            </p>
          </li>
          <li>
            <p>
              <strong>Professional Observatory: </strong>
              Gaze through the lens of my professional experiences. This observatory is a window to the stars of my
              career achievements and milestones. Witness the projects that have defined my professional path and the
              skills that make my work stand out.
            </p>
          </li>
          <li>
            <p>
              <strong>Fascination Factory: </strong>
              Step into a world where my personal interests and hobbies come alive. The Fascination Factory is a dynamic
              and ever-evolving space that showcases the hobbies and passions that fuel my creativity and bring balance
              to my life. From intricate 3D models to the harmonious strings of a guitar, this is where my personal
              interests are engineered into reality.
            </p>
          </li>
        </ul>
        <h3>A World of Interaction and Discovery</h3>
        <p>
          Planet Tim is more than a portfolio; it's a vivid adventure into a world where professional accomplishments,
          educational milestones, and personal interests blend in a harmonious symphony. Navigate freely, interact with
          each element, and immerse yourself in the experiences that have carved my identity and career. Prepare
          yourself for a journey of discovery, inspiration, and fascination. Welcome to Planet Tim – where each landmark
          is a beacon of my life's story, inviting you to explore, learn, and be inspired.
        </p>
      </div>
    </div>
  )
}
